import { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Button } from "V2.0/common/button";
import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import { PageIdSelect } from "./PageIdSelect";

function PageIdAdd(props) {
  const { workspaceId, onPageIdAdd, pageIds } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button outline onClick={() => setOpen(true)}>
        <PlusIcon /> Add Page
      </Button>
      {open && (
        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>Add Page</DialogTitle>
          <DialogBody>
            <PageIdSelect
              workspaceId={workspaceId}
              onSubmit={(data) => onPageIdAdd(data, () => setOpen(false))}
              onCancel={() => setOpen(false)}
              pageIds={pageIds}
            />
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}

export { PageIdAdd };
